import { render, staticRenderFns } from "./UpcomingPrograms.vue?vue&type=template&id=28ee5be6&scoped=true&"
import script from "./UpcomingPrograms.vue?vue&type=script&lang=js&"
export * from "./UpcomingPrograms.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingPrograms.vue?vue&type=style&index=0&id=28ee5be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee5be6",
  null
  
)

export default component.exports